export const iconFontAwesomeUsersPeoplePersonCircleCheck = (
	<i className="fa-solid fa-person-circle-check"></i>
);
